export default {
    LAST_FOUR_CREDIT_CARD: 'LAST_FOUR_CREDIT_CARD',
    CUSTOMER_NUMBER: 'CUSTOMER_NUMBER'
};


// WEBPACK FOOTER //
// ./src/modules/account-connector/components/proof-of-ownership/proofTypes.js